import React from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import OrderInputs from '../../components/OrderStatusInputs/OrderStatusInputs';
import { connect } from 'react-redux';
import {
  createOrderStatusRequestAction,
} from '../../store/orderStatus/orderStatusActions';
import { useTranslation } from '../../hooks/useTranslation';

const CreateOrderStatus = (props) => {
  const {
    createOrderStatusRequest,
    isLoading,
    createOrderStatusData,
  } = props;

  const navigate = useNavigate();
  const { t } = useTranslation();

  // Form submit handler
  const handleOrderSubmit = (orderStatusData) => {
    console.log('Submitting order:', orderStatusData);
    createOrderStatusRequest({
      data: orderStatusData,
      navigate: navigate
    });
  };

  // Back to orders page
  const handleBackToOrders = () => {
    navigate('/order-status');
  };

  return (
    <div>
      <CContainer>
        {/* Breadcrumb */}
        <CBreadcrumb className="mb-4">
          <CBreadcrumbItem 
            href="#/order-status" 
            onClick={(e) => { 
              e.preventDefault();
              handleBackToOrders();
            }}
          >
            {t('orders')}
          </CBreadcrumbItem>
          <CBreadcrumbItem active>{t('createOrder')}</CBreadcrumbItem>
        </CBreadcrumb>

        <CRow>
          <CCol xs={12}>
            <CCard>
              <CCardHeader>
                <h4 className="mb-0">{t('createOrder')}</h4>
              </CCardHeader>
              <CCardBody>
                <OrderInputs 
                  onSubmit={handleOrderSubmit}
                  onCancel={handleBackToOrders}
                  isLoading={isLoading}
                  submitResponse={createOrderStatusData}
                />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.loadingReducer?.isLoading || false,
    createOrderStatusData: state.orderStatusReducer?.createOrderStatusData || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createOrderStatusRequest: (payload) => {
      dispatch(createOrderStatusRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateOrderStatus);